// Current Live Placeholder Screen

import React from 'react';

export default function ComingSoon() {
  return (
    <div style={styles.container}>

      <p style={styles.text}>Coming Soon</p>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000000',
    fontFamily: "'Inter', sans-serif",
  },
  
  text: {
    fontSize: '18px',
    color: 'rgba(255,255,255,0.7)',
    letterSpacing: '2px',
  },
};